import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

function ContactContent() {
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_4pnlqg6', 'template_n9s6vrr', form.current, '1hazLTtB_ITHBT3si')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
      };
  return (
    <section className="contact_area section_gap">
        <div className="container">
            <div className="row">
                <div className="col-lg-3">
                    <div className="contact_info">
                        <div className="info_item">
                            <i className="lnr lnr-home"></i>
                            <h6>Ho Chi Minh City, Vietnam</h6>
                            <p></p>
                        </div>
                        <div className="info_item">
                            <i className="lnr lnr-phone-handset"></i>
                            <h6><a href="tel:754-264-8668">‪‪(754) 264-8668‬</a></h6>
                            <p>Mon to Fri 9am to 4 pm</p>
                        </div>
                        <div className="info_item">
                            <i className="lnr lnr-envelope"></i>
                            <h6><a href="mailto:anhdev93@gmail.com">anhdev93@gmail.com</a></h6>
                            <p>Send me your message anytime!</p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-9">
                    <form ref={form} onSubmit={sendEmail} className="row contact_form">
                        <div className="col-md-6">
                            <div className="form-group">
                                <input type="text" className="form-control" id="name" name="name" placeholder="Enter your name"/>
                            </div>
                            <div className="form-group">
                                <input type="email" className="form-control" id="email" name="email" placeholder="Enter email address"/>
                            </div>
                            <div className="form-group">
                                <input type="text" className="form-control" id="subject" name="subject" placeholder="Enter Subject"/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <textarea className="form-control" name="message" id="message" rows="1" placeholder="Enter Message"></textarea>
                            </div>
                        </div>
                        <div className="col-md-12 text-right">
                            <button type="submit" value="submit" className="primary_btn">
                                <span>Send Message</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div id="mapBox" className="mapBox" 
                data-lat="10.8231" 
                data-lon="106.6297" 
                data-zoom="13" 
                data-info="No 30, Dai Duong Villas, Binh Than Street, Dai Phuc District, Ho Chi Minh City, Vietnam"
                data-mlat="10.8231"
                data-mlon="106.6297">
            </div>
        </div>
    </section>
  )
}

export default ContactContent;